var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.19408 1.99916C2.12064 2.15145 2.08199 2.32429 2.08203 2.50023V9.49977C2.08199 9.67571 2.12064 9.84855 2.19408 10.0008C2.26752 10.1531 2.37315 10.2795 2.50031 10.3671C2.62747 10.4548 2.77165 10.5006 2.9183 10.5C3.06494 10.4994 3.20886 10.4524 3.33552 10.3637L8.33613 6.86394C8.46217 6.77585 8.56673 6.6496 8.63937 6.49783C8.712 6.34606 8.75016 6.17408 8.75003 5.99907C8.74991 5.82406 8.7115 5.65215 8.63864 5.50054C8.56579 5.34892 8.46105 5.22289 8.33488 5.13506L3.33552 1.63629C3.20886 1.54761 3.06494 1.5006 2.9183 1.50001C2.77165 1.49941 2.62747 1.54524 2.50031 1.63289C2.37315 1.72053 2.26752 1.84687 2.19408 1.99916Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPlay);
export default __webpack_public_path__ + "static/media/photo-play.47c7f48fc05414a1c7044ec188dfef59.svg";
export { ForwardRef as ReactComponent };